/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

import React from "react";
import { useIsAuthenticated } from "@azure/msal-react";
import { SignInButton } from "./components/SignInButton";
import { SignOutButton } from "./components/SignOutButton";

export const PageLayout = (props) => {
  const isAuthenticated = useIsAuthenticated();

  return (
    <div className="p-4 bg-white border rounded-md card shadow  flex flex-col items-center mx-auto justify-center">
      <nav bg="primary" variant="dark" className="navbarStyle">
        <a className="navbar-brand" href="/">
          Microsoft Identity Platform
        </a>
        <div className="flex justify-center  flex-row flex-center my-4">
          {isAuthenticated ? <SignOutButton /> : <SignInButton />}
        </div>
      </nav>
      <div className="profileContent">{props.children}</div>
    </div>
  );
};
